import type { PropsWithChildren } from 'react';
import React from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import { Layout } from './Layout';
import { prefetch } from './prefetch';
import type { DefaultLayoutProps } from './shared/types';

export const DefaultLayout = withPrefetchedData(
	({
		children,
		...props
	}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
		return <Layout {...props}>{children}</Layout>;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => {
			await prefetch(context);
		},
	},
);
